"use client";

import { useSession } from "../components/SupabaseProvider";
import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { createQuickActionWriter } from "../components/publicationFlow/quickActions";
import { saveSchedulingBatch, type SchedulingBatchRequest } from "../components/publicationFlow/schedulingBatch";

export function usePublicationQuickAction() {
  const session = useSession();
  const token = useRef(session?.access_token ?? "");
  token.current = session?.access_token ?? "";
  const queryClient = useQueryClient();
  const writer = useRef<ReturnType<typeof createQuickActionWriter> | null>(null);
  writer.current ??= createQuickActionWriter(request => saveSchedulingBatch(request, token.current));

  return async (createRequest: () => SchedulingBatchRequest) => {
    try {
      await writer.current!.run(createRequest);
    } finally {
      // Refresh on conflicts and uncertain responses as well as success.
      await queryClient.refetchQueries({ queryKey: ["publications"], exact: false });
    }
  };
}
